import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class FrontDeskCancellationReport extends AbstractReport {
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'room_type',
    'reservation_id',
    'guest_id',
    'number_of_nights',
)(FrontDeskCancellationReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/front-desk/cancellation-report.model.js